import { apiClient, unwrap } from '@/lib/apiClient';
import type { NotificationSource } from '@/features/notifications/api/notifications.api';
import type { ApiSuccess } from '@/types/api';
import type { NotificationInbox } from '@/types/notification';

/**
 * The parent's own inbox, for the bell in the parent panel.
 *
 * The same shape as the staff inbox, under `/parent` — a parent never reaches
 * the institute routes. No path names a recipient: the server reads the
 * account from the token.
 */
export const parentNotificationsApi: NotificationSource = {
  inbox: () => unwrap(apiClient.get<ApiSuccess<NotificationInbox>>('/parent/notifications')),

  markRead: (uuid: string) =>
    unwrap(apiClient.patch<ApiSuccess<null>>(`/parent/notifications/${uuid}/read`)),

  markAllRead: () =>
    unwrap(apiClient.post<ApiSuccess<{ count: number }>>('/parent/notifications/read-all')),
};
